"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PackagesLoader = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _jsxRuntime = require("react/jsx-runtime");
const LoaderContainer = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'grid',
  rowGap: '15px',
  [theme.breakpoints.up('md')]: {}
}));
const ItemLoader = (0, _mui.styled)(_mui.Skeleton)({
  transform: 'scale(1)'
});
const PackageLoader = ({
  skeletonItemsPackage = 1,
  height,
  width
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
  children: Array.from({
    length: skeletonItemsPackage
  }).fill(1).map((_, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(ItemLoader
  // eslint-disable-next-line react/no-array-index-key -- Items always look exactly the same, so it's safe to use index here.
  , {
    width: width,
    height: height
  }, index))
});
const PackagesLoader = () => {
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const {
    breakpoints
  } = (0, _mui.useTheme)();
  const isMobile = (0, _mui.useMediaQuery)(breakpoints.down('md'));
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(LoaderContainer, {
    ...getTestIdProps('packages-loader'),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Skeleton, {
      height: 26,
      width: 72
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(PackageLoader, {
      width: isMobile ? '100%' : '372px',
      height: 60
    })]
  });
};
exports.PackagesLoader = PackagesLoader;
